/* eslint-disable no-script-url */
import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

import EnhancedMenu from "../../../components/EnhancedMenu";
import Grid from "@material-ui/core/Grid";
import menuItems from "../../../data/link-placements";
import palette from "../../../theme/palette";
import StatsContext from "../../../context/StatsContext";

const useStyles = makeStyles({
  root: {
    backgroundColor: palette.common.yellow,
    width: "100%",
    height: "100%",
    padding: "2.5rem",
    boxShadow: "none"
  },
  depositContext: {
    margin: "2rem 0"
  },
  button: {
    paddingTop: "9px",
    paddingBottom: "9px"
  },
  textField: {
    padding: "5px"
  }
});

export default function LinksChoosePlacement(props) {
  const classes = useStyles();
  const [anchorElement, setAnchorElement] = React.useState(null);
  const statsRange = React.useContext(StatsContext);
  function handleButtonClick(event) {
    setAnchorElement(event.currentTarget);
  }

  function handleMenuClose() {
    setAnchorElement(null);
  }

  function handleMenuItemClick(event) {
    let hasValidated = props.values.placement_type !== "" ? 2 : 1;
    console.log(event);
    const source =
      event.medium === "ekomm" ? statsRange.partnerCode : event.source;
    props.setValues({
      ...props.values,
      placement: event.caption,
      placement_id: event.key,
      placement_source: source,
      placement_medium: event.medium,
      placement_campaign: event.medium,
      isValidated: hasValidated
    });

    setAnchorElement(null);
  }

  return (
    <>
      <Grid item xs={12} sm={4}>
        <TextField
          id="filled-name"
          label="Hvor skal linken være?"
          placeholder="Velg et alternativ"
          className={classes.textField}
          onClick={handleButtonClick}
          value={props.values.placement}
          margin="normal"
          variant="filled"
          autoComplete="off"
          InputLabelProps={{
            shrink: true
          }}
        />
      </Grid>

      <EnhancedMenu
        open={Boolean(anchorElement)}
        menuItems={menuItems}
        anchorElement={anchorElement}
        onClose={handleMenuClose}
        onMenuItemClick={handleMenuItemClick}
      />
    </>
  );
}
